import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { BulkDesignTagDocument } from './bulk.generated';

export const useBulkDesignTag = (options: ApiOptions<typeof BulkDesignTagDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(BulkDesignTagDocument, {
    ...useNotifications(BulkDesignTagDocument, {
      failure: t('api.design_tags.bulk_add_error'),
      success: (data) => {
        const count = data.bulkTag?.taggables.length ?? 0;
        return t('api.design_tags.bulk_add_success_plural', { count });
      },
    }),
    ...options,
  });
};
